import { Backdrop, Box, Button, Divider, Fade, Modal, Paper, Skeleton, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useLang } from '../../../../language';

const modalStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 640,
    maxWidth: '94%',
    maxHeight: '88vh',
    overflowY: 'auto' as 'auto',
    overflowX: 'hidden' as 'hidden',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
}

/**
 * Modal de detall d'una notícia del WS d'Activitats.
 *
 * Mentre el detall es carrega (prop `cargando`) només es mostra el skeleton;
 * el contingut no apareix fins que la resposta del WS ha arribat completa.
 */
export const ModalNoticia = ({ noticia, detalle, cargando, onClose }: any) => {

    const Lang = useLang()

    return (
        <Modal
            open={!!noticia}
            onClose={onClose}
            aria-labelledby="modal-noticia"
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 200,
            }}
        >
            <Fade in={!!noticia}>

                <Paper sx={modalStyle}>

                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, borderBottom: '1px solid', borderColor: 'divider', position: 'sticky', top: 0, bgcolor: 'background.paper', zIndex: 1 }}>

                        <Typography variant='h6' className='fw-500 my-0'>
                            {Lang('NOTICIA')}
                        </Typography>

                        <Button
                            size="small"
                            color="inherit"
                            onClick={onClose}
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </Button>
                    </Box>

                    {
                        noticia &&
                        <Box className='p-3'>

                            {
                                cargando &&
                                <Box>
                                    <Skeleton variant="rectangular" animation="wave" sx={{ borderRadius: 1.5, mb: 2, height: 200 }} />
                                    <Skeleton variant="text" animation="wave" width="80%" />
                                    <Skeleton variant="text" animation="wave" width="40%" />
                                    <Skeleton variant="text" animation="wave" />
                                    <Skeleton variant="text" animation="wave" />
                                    <Skeleton variant="text" animation="wave" width="60%" />
                                </Box>
                            }

                            {
                                !cargando &&
                                <Box>

                                    {
                                        (detalle?.imagen || noticia.imagen) &&
                                        <Box
                                            component="img"
                                            src={detalle?.imagen || noticia.imagen}
                                            alt={detalle?.titulo || noticia.titulo}
                                            sx={{
                                                width: '100%',
                                                height: 260,
                                                objectFit: 'contain',
                                                bgcolor: 'grey.100',
                                                borderRadius: 1.5,
                                                mb: 2,
                                                display: 'block',
                                            }}
                                        />
                                    }

                                    <Typography variant='h6' className='fw-500 my-0 mb-1'>
                                        {detalle?.titulo || noticia.titulo}
                                    </Typography>

                                    <Typography variant='body2' className='mb-2' sx={{ color: 'text.secondary' }}>
                                        <FontAwesomeIcon icon={faCalendarAlt} style={{ marginRight: 6, fontSize: 12 }} />
                                        {Lang('DATA')}: {detalle?.fecha || noticia.fecha}
                                    </Typography>

                                    <Divider className='my-2' />

                                    <Typography variant='body2'>
                                        {detalle?.contenido || detalle?.resumen || noticia.resumen}
                                    </Typography>

                                    {
                                        (detalle?.enlace || noticia.enlace) &&
                                        <Box className='mt-3' sx={{ textAlign: 'right' }}>
                                            <Button
                                                size="small"
                                                color="primary"
                                                variant="contained"
                                                href={detalle?.enlace || noticia.enlace}
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                {Lang('MES_INFORMACIO')}
                                            </Button>
                                        </Box>
                                    }

                                </Box>
                            }

                        </Box>
                    }

                </Paper>

            </Fade>
        </Modal>
    )
}

export default ModalNoticia